// Essential polyfills for older browser compatibility - must be loaded synchronously
import "core-js/actual"; // covers most compatibility issues
import "isomorphic-fetch"; // for fetch API

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

/**
 * Defer non-critical polyfills to load after initial render.
 * These polyfills enhance functionality but are not essential for initial page load.
 */
const loadDeferredPolyfills = async () => {
  // IntersectionObserver polyfill - needed for lazy loading and visibility detection
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore - dynamic import for polyfill without types
  await import("intersection-observer-polyfill/index.global");
  // Scroll behavior polyfill - needed for smooth scrolling on older browsers
  await import("scroll-behavior-polyfill");
};

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// Load non-critical polyfills after initial render
if (typeof window !== "undefined") {
  // Use requestIdleCallback for better performance, or setTimeout as fallback
  if ("requestIdleCallback" in window) {
    (
      window as typeof window & {
        requestIdleCallback: (cb: () => void) => void;
      }
    ).requestIdleCallback(loadDeferredPolyfills);
  } else {
    setTimeout(loadDeferredPolyfills, 100);
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
